import React from 'react';
import ScrollFocusComponent from '@synergycms_core/components/HoC/scrollFocusComponent';
import { compose, values, drop, append, remove, map, pipe,range,dropLast,reduce } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './engineDropDownOccup.js';
import Button from '../../generic/Button';
import RichText from '@synergycms_core/components/generic/RichText';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { withContent } from '@synergycms_core/components/providers/translateProvider';

const manageIncrements = (increment, currentValue = 0, maxVal, minVal) => {
  const updateVal = currentValue + increment;
  if (updateVal > maxVal) {
    return maxVal;
  } else if (updateVal < minVal) {
    return minVal;
  } else {
    return updateVal;
  }
};

const AgeSelector = ({start, end, changeAge, age, content, classes}) => {
  return (
    <div className={classes.customSelectContainer}>
      <select value={age} onChange={changeAge} className={classes.customSelect}>
        {range(start, end + 1).map(age => (
          <option key={age} value={age}>{age + ' ' + content.t('_%año%_',  age !== 1)}</option>
        ))}
      </select>
    </div>
  );
}

const ManageOccupRoom = compose(withThemeJSS({ displayName: 'EngineDropDownOccup', styleFile, link: true }))(props => {
  const { theme, room, roomIdx, occups, enableChilds, content, enableAge, modalBreak } = props;


  const manageOccups = props.manageOccups;
  const manageRooms = props.manageRooms;
  const changeAge = props.changeAge;
  const { classes } = theme.styles;
  const { baby: babiesRange, child: childsRange } = props.childsInfo || {};
  const enableAgeSelector = enableAge && room.childsAge?.length > 0;
  const { rooms = { max: 10 }, adults = { max: 8, min: 1 }, childs = { max: 4, min: 0 } } = props.limits;

  const checkDisabled = (occupType, comparasionType, occupNumber) => {
    let occup = occups.find(occup => occup.idx === room.idx);
    return occup ?
      (comparasionType === 'min') ?
        !occup[occupType] || occup[occupType] <= occupNumber :
        occup[occupType] >= occupNumber :
      false;
  };

  return (
    <div>
      {!modalBreak && (
        <>
          <div className={classes.tableLine}>
            <div className={classes.box} tabIndex={0}>
              <RichText innerStyle={classes.ariaHidden} translate={true} ariaLabel={'_%ocupacion%_'} />
              <RichText innerStyle={classes.roomListTitle} ucFirst={true} translate={true} text={'_%habitación%_'} ariaLabel={'_%habitación%_'}/>{' '}
              <RichText innerStyle={classes.roomListTitle} text={roomIdx + 1} ariaLabel={roomIdx + 1}/>
            </div>
            <div className={classes.box}>
              <div className={classes.relativeElement} aria-label={room.adults + content.t('_%adulto%_')} tabIndex={0}>
                <Button innerStyle={classes.button} onClick={manageOccups(-1, roomIdx, 'adults')} disabled={checkDisabled('adults','min',adults.min)} translate={true} ariaLabel={'_%eliminar adulto%_'}/>
                <div className={classes.roomNumbers}>
                  <RichText innerStyle={'roboto13Black'} text={room.adults} />{' '}
                  <RichText innerStyle={'roboto13Black'} translate={true} quantity={room.adults} text={'_%adulto%_'} />
                </div>
                <Button innerStyle={classes.buttonAdd} onClick={manageOccups(1, roomIdx, 'adults')} disabled={checkDisabled('adults','max',adults.max)} translate={true} ariaLabel={'_%añadir adulto%_'}/>
              </div>
            </div>
            {enableChilds && <div className={classes.box}>
              <div className={classes.relativeElement} >
                <Button innerStyle={classes.button} onClick={manageOccups(-1, roomIdx, 'childs')} disabled={checkDisabled('childs','min',childs.min)} translate={true} ariaLabel={'_%eliminar niño%_'}/>
                <div className={classes.roomNumbers} tabIndex={0}>
                  <RichText innerStyle={'roboto13Black'} text={room.childs || '0'} />{' '}
                  {(room.childs < 5 || !room.childs) && (
                    <React.Fragment>
                      <RichText
                        quantity={room.childs || 0}
                        translate={true}
                        innerStyle={'roboto13Black'}
                        text={'_%niño%_'}
                      />
                      <RichText
                        innerStyle={'roboto13Black'}
                        text={'*'}
                        ariaHidden={true}
                      />
                    </React.Fragment>
                  )}
                  {room.childs > 5 && <React.Fragment>
                    <RichText
                      translate={true}
                      innerStyle={'roboto13Black'}
                      text={'_%niños2%_'}
                    />
                    <RichText
                      innerStyle={'roboto13Black'}
                      text={'*'}
                      ariaHidden={true}
                    />
                  </React.Fragment>}
                </div>
                <Button innerStyle={classes.buttonAdd} onClick={manageOccups(1, roomIdx, 'childs')} disabled={checkDisabled('childs','max',childs.max)} translate={true} ariaLabel={'_%añadir niño%_'}/>
              </div>
            </div>}
            <div className={[classes.box, classes.deleteRoomContainer].join(' ')}>
              {occups.length >= 2 && (
              <Button
                  innerStyle={classes.removeRoom}
                  onClick={manageRooms(-1, roomIdx)}
                  icon={{
                  unicodeContent: 'e08a',
                    innerStyle: classes.removeRoomIcon
                  }}
                  translate={true}
                  ariaLabel={'_%eliminar habitacion completa%_'}
                />
              )}
            </div>
          </div>
          {enableAgeSelector &&
          <div className={classes.childAgesContainer}>
            <div className={classes.childAgesText}>
              <RichText innerStyle={'roboto14Black'} translate={true} ucFirst={true} text={'_%edad del niño%_'} plural={room.childsAge.length > 1} />
            </div>
            <div className={classes.childAgesSelect}>
              {room.childsAge.map((child,index) => (
                <AgeSelector
                  key={index}
                  age={child.age}
                  changeAge={(event) => changeAge(roomIdx, index, event.target.value)}
                  start={babiesRange.start}
                  end={childsRange.end}
                  classes={classes}
                  content={content}
                />
              ))}
            </div>
          </div>}
        </>
      )}
      {modalBreak && (
        <>
          <div className={classes.tableLine}>
            <div className={classes.box} tabIndex={0}>
              <div className={classes.textRoom}>
              <RichText innerStyle={classes.ariaHidden} translate={true} ariaLabel={'_%ocupacion%_'} />
                <RichText innerStyle={classes.roomListTitle} ucFirst={true} translate={true} text={'_%habitación%_'} ariaLabel={'_%habitación%_'} />{' '}
                <RichText innerStyle={classes.roomListTitle} text={roomIdx + 1} ariaLabel={roomIdx + 1}/>
              </div>
                {occups.length >= 2 && (
                  <Button
                    innerStyle={classes.removeRoom}
                    onClick={manageRooms(-1, roomIdx)}
                    icon={{
                      unicodeContent: 'e08a',
                      innerStyle: classes.removeRoomIcon
                    }}
                    disabled={occups.length === rooms.min}
                    translate={true}
                    ariaLabel={'_%eliminar habitacion completa%_'}
                  />
                )}
            </div>
            <div className={classes.box}>
              <div className={classes.personSelector} tabIndex={0}>
                <Button innerStyle={classes.button} onClick={manageOccups(-1, roomIdx, 'adults')} disabled={checkDisabled('adults','min',adults.min)} translate={true} ariaLabel={'_%eliminar adulto%_'}/>
                <div className={classes.roomNumbers}>
                  <RichText innerStyle={'roboto13Black'} text={room.adults} />{' '}
                  <RichText innerStyle={'roboto13Black'} translate={true} quantity={room.adults} text={'_%adulto%_'} />
                </div>
                <Button innerStyle={classes.buttonAdd} onClick={manageOccups(1, roomIdx, 'adults')} disabled={checkDisabled('adults','max',adults.max)}translate={true} ariaLabel={'_%añadir adulto%_'} />
              </div>
              {enableChilds && <div className={classes.personSelector}>
                <Button innerStyle={classes.button} onClick={manageOccups(-1, roomIdx, 'childs')} disabled={checkDisabled('childs','min',childs.min)} translate={true} ariaLabel={'_%eliminar niño%_'} />
                <div className={classes.roomNumbers} tabIndex={0}>
                  <RichText innerStyle={'roboto13Black'} text={room.childs || '0'} />{' '}
                  {(room.childs < 5 || !room.childs) && (
                    <React.Fragment>
                      <RichText
                        quantity={room.childs || 0}
                        translate={true}
                        innerStyle={'roboto13Black'}
                        text={'_%niño%_'}
                      />
                      <RichText
                        innerStyle={'roboto13Black'}
                        text={'*'}
                        ariaHidden={true}
                      />
                    </React.Fragment>
                  )}
                </div>
                <Button innerStyle={classes.buttonAdd} onClick={manageOccups(1, roomIdx, 'childs')} disabled={checkDisabled('childs','max',childs.max)} translate={true} ariaLabel={'_%añadir niño%_'}/>
              </div>}
            </div>
          </div>
          {enableAgeSelector &&
          <div className={classes.childAgesContainer}>
            <div className={classes.childAgesText}>
              <RichText innerStyle={'roboto14Black'} translate={true} ucFirst={true} text={'_%edad del niño%_'} plural={room.childsAge.length > 1} />
            </div>
            <div className={classes.childAgesSelect}>
              {room.childsAge.map((child,index) => (
                <AgeSelector
                  key={index}
                  age={child.age}
                  changeAge={(event) => changeAge(roomIdx, index, event.target.value)}
                  start={babiesRange.start}
                  end={childsRange.end}
                  classes={classes}
                  content={content}
                />
              ))}
            </div>
          </div>}
        </>
      )}
    </div>
  );
});

class EngineDropDownOccup extends React.Component {
  static displayName = 'EngineDropDownOccup';

  constructor(props) {
    super(props);
    this.i = 0;
    const { childsInfo } = this.props.config;
    this.limits = this.props.config.limits || {};
    this.enableAge = !!childsInfo;
    this.childsInfo = childsInfo;



    this.state = {
      occups: pipe(
        values,
        map(segment => {
          segment.idx = this.identifier();
          const countInitChilds = segment.childs && (segment.childs - (segment.childsAge?.length || 0)) || 0;
          if(this.enableAge){
            segment.childsAge = reduce((result, value) => {
              result.push({idx:result.length +1 , age : this.limits.childs.defaultAge})
              return result;
            }, segment.childsAge || [], range(0, countInitChilds));
          }
          return segment;
        })
      )(props.config.occups)
    };



    this.cx = props.theme.bind();
  }

  identifier = () => {
    this.i = this.i + 1;
    return this.i;
  };

  manageRooms = (increment, room) => e => {
    this.setState(
      state => {
        if (room) {
          state.occups = remove(room, 1, state.occups);
        } else {
          const { rooms = { max: 10 }, adults = { default: 2 }, childs = { default: 0 } } = this.limits;
          if (increment === -1) {
            state.occups = state.occups.length > 1 ? drop(1)(state.occups) : state.occups;
          } else if (state.occups.length < rooms.max) {
            state.occups = append(
              { adults: adults.default, childs: childs.default, idx: this.identifier(), childsAge: []},
              state.occups
            );
          }
        }

        return { occups: state.occups };
      },
      () => {
        this.props.config.updateOccups(this.state.occups);
      }
    );
  };

  manageOccups = (increment, room, type) => () => {
    this.setState(
      state => {
        const { adults = { max: 8, min: 1 }, childs = { max: 4, min: 0, defaultAge: 10 }} = this.limits;

        const ocuupType = type === 'adults' ? adults : childs;
        state.occups[room][type] = manageIncrements(increment, state.occups[room][type], ocuupType.max, ocuupType.min);
        if(this.enableAge && type === "childs") {

          state.occups[room].childsAge = increment > 0
            ? append({ age:childs.defaultAge, idx: state.occups[room].childsAge?.length || 1 }, state.occups[room].childsAge || [])
            : dropLast(1, state.occups[room].childsAge);
        }
        return { occups : state.occups };
      },
      () => {
        this.props.config.updateOccups(this.state.occups);
      }
    );
  };

  changeAge = (room, position, age) =>{
    this.setState(
      state => {
        state.occups[room].childsAge[position].age = parseInt(age, 10);
        return { occups : state.occups };
      },
      () => {
        this.props.config.updateOccups(this.state.occups);
      }
    );
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return null;
  }

  render() {
    const { theme, content, config } = this.props;
    const { classes } = theme.styles;
    const { rooms = { max: 10, min : 1 }, childs = { default: 0, max: 0  } } = this.limits;
    const { baby: { start: babiesStart, end: babiesEnd} = {}, child: { start: childsStart, end: childsEnd } = {} } = this.childsInfo || {};
    const { maxHeight } = config;

    return (
      <div
        onClick={e => e.stopPropagation()}
        className={[ theme.computedInnerStyle ].join(' ')}>
        <div className={classes.roomLine}>
          <div className={classes.roomContainer}>
            <Button translate={true} innerStyle={classes.button} onClick={this.manageRooms(-1, null)} disabled={this.state.occups.length === rooms.min} ariaLabel={'_%eliminar una habitacion%_'}/>
            <div className={classes.numberBox} tabIndex={0}>
              <RichText innerStyle={'roboto13Black'} plural={true} text={this.state.occups.length} />{' '}
              <RichText innerStyle={'roboto13Black'} ucFirst={true} translate={true} quantity={this.state.occups.length} text={'_%habitación%_'} />
            </div>
            <Button translate={true} innerStyle={classes.buttonAdd} onClick={this.manageRooms(1, null)} disabled={this.state.occups.length === rooms.max} ariaLabel={'_%añadir otra habitacion%_'}/>
          </div>
        </div>
        <div className={classes.roomList} style={{maxHeight: maxHeight.toString() + 'px'}}>
          <TransitionGroup>
            {this.state.occups.map((room, roomIdx) => {
              return (
                <CSSTransition
                  appear={true}
                  exit={true}
                  key={room.idx}
                  timeout={300}
                  classNames={{
                    enter: classes.occupsEnter,
                    enterActive: classes.occupsEnterActive,
                    exit: classes.occupsLeave,
                    exitActive: classes.occupsLeaveActive
                  }}>
                  <div className={classes.line}>
                      <div className={classes.lineContent}>
                        <ManageOccupRoom
                          enableChilds={!!childs.max}
                          childsInfo={this.childsInfo}
                          enableAge={this.enableAge}
                          room={room}
                          roomIdx={roomIdx}
                          occups={this.state.occups}
                          manageOccups={this.manageOccups}
                          manageRooms={this.manageRooms}
                          changeAge={this.changeAge}
                          limits={this.limits}
                          content={content}
                          modalBreak={config.modalBreak}
                        />
                      </div>
                  </div>
                </CSSTransition>
              );
            })}
          </TransitionGroup>

          {!!childs.max && <div className={classes.extraLine}>
            <RichText
              ucFirst={true}
              translate={true}
              text={'_%*Niños de 2 a 11 años%_'}
              withVars={{
                babiesStart,
                babiesEnd,
                childsStart,
                childsEnd
              }}
              innerStyle={classes.extraText}
            />
          </div>}
        </div>
        {!config.modalBreak && (
          <div className={classes.occupFooter}>
            <div className={classes.tableLine}>
                <div className={classes.box}>
                  <Button
                    id="td-search-guests-00"
                    onClick={this.props.config.executeSearch}
                    innerStyle={['toggleMainButtonReverse', classes.confirmButton]}
                    richText={{ text: '_%confirmar%_', translate: true, ucFirst: true }}
                    ariaLabel={'_%confirmar busqueda%_'}
                    translate={true}
                  />
                </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  PropertyManager(['occups', 'updateOccups', 'limits','childsInfo', 'executeSearch','maxHeight', 'modalBreak']),
  ScrollFocusComponent({}),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(EngineDropDownOccup);
